import type {
    CreatePillarRequest,
    Pillar,
    PillarObjectiveAlignment,
    UpdatePillarRequest,
} from '@/types/pillars';

import { api } from '@/api/api';

export default {
    async getPillars(): Promise<Pillar[]> {
        const response = await api.get('/Pillar');
        return response.data;
    },

    async getObjectiveAlignment(): Promise<PillarObjectiveAlignment> {
        const response = await api.get('/Pillar/ObjectiveAlignment');
        return response.data;
    },

    async getPillarById(id: string): Promise<Pillar> {
        const response = await api.get(`/Pillar/${id}`);
        return response.data;
    },

    async createPillar(request: CreatePillarRequest): Promise<Pillar> {
        const response = await api.post('/Pillar', request);
        return response.data;
    },

    async updatePillar(id: string, request: UpdatePillarRequest): Promise<Pillar> {
        const response = await api.put(`/Pillar/${id}`, request);
        return response.data;
    },

    async deletePillar(id: string): Promise<Pillar> {
        const response = await api.delete(`/Pillar/${id}`);
        return response.data;
    },

    async togglePillarStatus(id: string): Promise<Pillar> {
        const response = await api.patch(`/Pillar/${id}/ToggleStatus`);
        return response.data;
    },
};
